/* eslint-disable react/no-unknown-property */
import {
  FontWeight, HStack, Popover, PopoverProps, Stack, Text,
} from '@doveit/bricks';
import React from 'react';
import { pluralizeWord } from '@doveit/hammer';
import { CoveredGeo } from '../../../providers/api/dtos';
import * as styles from './ProvincePopover.style';

export interface ProvincePopoverProps extends React.AriaAttributes {
  coveredGeo?: CoveredGeo[],
  trigger: PopoverProps['trigger'],
}

const ProvincePopover: React.FC<ProvincePopoverProps> = ({
  coveredGeo,
  trigger,
  ...rest
}) => {
  const provincesCount = coveredGeo?.length || 0;
  const title = provincesCount === 0
    ? "Nessuna provincia coperta dall'agente"
    : `${provincesCount} ${pluralizeWord('provinc', 'ia coperta', 'e coperte', provincesCount)}`;

  return (
    <Popover
      trigger={trigger}
      hasArrow
      {...rest}
    >
      <div css={styles.wrapper}>
        <Stack gap={150}>
          <Text.BodySmall
            as="strong"
            fontWeight={FontWeight.MEDIUM}
          >
            {title}
          </Text.BodySmall>

          <Stack gap={100}>
            {coveredGeo?.map((geo) => (
              <HStack
                key={geo.plateCode}
                alignItems="center"
                justifyContent="space-between"
              >
                <Text.BodySmall fontWeight={FontWeight.REGULAR}>
                  {geo.province}
                </Text.BodySmall>

                <hr css={styles.coveredGeoDashedLine} />

                <HStack>
                  <Text.BodySmall
                    as="strong"
                    fontWeight={FontWeight.MEDIUM}
                  >
                    {Math.round(geo.weight * 100).toFixed(0)}%
                  </Text.BodySmall>
                </HStack>

              </HStack>
            ))}
          </Stack>
        </Stack>
      </div>
    </Popover>
  );
};

export default ProvincePopover;
